import { httpInstance } from '@/services/httpInstance';

const updateDistributionCenterService = async (dataParam) => {
  let res;
  const endpoint = '/delivery/v1/distribution-centers';
  const dataSent = dataParam;

  await httpInstance.put(
    endpoint,
    dataSent,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default updateDistributionCenterService;
